import type { Pitch, PitchStatus } from "../../shared/types";

/** Selected pitch statuses. Empty means no constraint. */
export type PitchStatusFilter = readonly PitchStatus[];

export const emptyPitchStatusFilter: PitchStatusFilter = Object.freeze([]);

export function pitchMatchesStatusFilter(pitch: Pick<Pitch, "status">, filter: PitchStatusFilter): boolean {
    return filter.length === 0 || filter.includes(pitch.status);
}

export function pitchStatusFilterCount(filter: PitchStatusFilter): number {
    return filter.length;
}
